import { Component, OnInit } from '@angular/core';
import { Auth, ViewState} from 'src/common'
@Component({
  selector: 'role-create',
  templateUrl: './role-create.component.html'

})
export class RoleCreateComponent  implements OnInit{

  viewState = ViewState;

  constructor() { }

  ngOnInit (): void {
    Auth.checkAuthorization('1EE5706A-01F2-44A2-98AE-510C9605DEE4');
  }
}
